import { render, staticRenderFns } from "./customExportsList.vue?vue&type=template&id=df4b1a7a&"
import script from "./customExportsList.vue?vue&type=script&lang=js&"
export * from "./customExportsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports